import { Component, Input, OnInit } from '@angular/core';
import { PageEvent as PageEvent } from '@angular/material/paginator';
import { MatSnackBar as MatSnackBar } from '@angular/material/snack-bar';
import {Account, Project} from 'src/app/shared/models';
import { ProjectService } from 'src/app/shared/services';

@Component({
    selector: 'app-project-accounts',
    templateUrl: './project-accounts.component.html',
    styleUrls: ['./project-accounts.component.scss'],
    standalone: false
})
export class ProjectAccountsComponent implements OnInit {

  public loading = 0;
  public initialized = false;

  @Input()
  public project: Project;

  @Input()
  public pageSize = 20;

  public accounts: Account[] = [];
  public pagination = {
    pageIndex: 0,
    length: 0,
    pageSize: this.pageSize,
  };

  constructor(
    private projectService: ProjectService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.pagination.pageSize = this.pageSize;
    this.getAccounts();
  }

  /**
   * Get project accounts
   */
  getAccounts() {
    this.projectService.getAccounts(this.project, this.pagination, { include: 'roles' })
      .subscribe({
        next: (resp: any) => {
          this.accounts = resp.result;
          this.pagination.length = resp.meta.totalRecords || 0;
          this.initialized = true;
        },
        error: (err: any) => {
          this.snackBar.open(err.message, '', { duration: 6000 });
        }
      });
  }

  /**
   * Get the role name for the current project only
   * @param account The account to get the role for
   * @returns The role name for the current project or null if not found
   */
  getCurrentProjectRole(account: Account): string | null {
    if (!account?.roles || !Array.isArray(account.roles) || !this.project) {
      return null;
    }

    const projectRole = account.roles.find(role =>
      role.project_id === this.project.id
    );

    return projectRole ? projectRole.role_name : null;
  }

  pageChanged(event: PageEvent) {
    this.pagination = event;
    this.getAccounts();
  }

}
